<template>
    <v-container class="fill-height" style="display: block; padding: 0px;" fluid>

        <div class="title-area">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                <path fill="#C74634" fill-rule="evenodd" d="M31.722 11C39.056 11 45 16.818 45 23.995 45 31.182 39.056 37 31.722 37l-15.44-.006C8.948 36.994 3 31.179 3 23.995 3 16.818 8.948 11 16.282 11h15.44zm-.35 4.585H16.628c-4.749 0-8.6 3.765-8.6 8.41 0 4.652 3.851 8.42 8.6 8.42h14.746c4.749 0 8.603-3.768 8.603-8.42 0-4.645-3.854-8.41-8.603-8.41z"/>
            </svg>
            <span class="title ns"><b>NET</b>SUITE Transfer Orders</span>
            <div class="d-inline-block float-right" v-if="!gettingNetsuiteResources">
                <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-btn color="#c42111" @click="manualResyncResources" v-on="on" width="40" max-width="40" min-width="40">
                            <v-icon>mdi-sync</v-icon>
                        </v-btn>
                    </template>
                    <span>Sync Resources</span>
                </v-tooltip>
            </div>
        </div>



        <div class="transfer-orders-area" v-if="!gettingNetsuiteResources">
            <div id="netsuite-transfer-order-ag-grid-container">
                <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                    :gridOptions="gridOptions"
                    @row-double-clicked="(params) => editTransferOrder(params.data)"
                    :groupHeaders="true"
                    :rowHeight="40">
                </ag-grid-vue>
            </div>
            <v-btn class="mt-2 mb-3" color="#c42111" @click="addTransferOrderClick" v-if="showGrid">Add New</v-btn>
        </div>

        <div class="getting-ns-resources" v-if="gettingNetsuiteResources">
            <span>Getting NetSuite Resources...</span>
            <v-progress-linear class="progress-bar" indeterminate color="#c42111" striped height="8"></v-progress-linear>
        </div>

        
        <v-dialog v-model="showTransferOrderEdit" width="1800px" max-width="80%" persistent @keydown="(k) => {k.key == 'Escape' ? showTransferOrderEdit = false : null}" v-if="showTransferOrderEdit">
            <transfer-order-edit :transferOrder="selectedTransferOrderClone" :resources="resources" @save="saveTransferOrder" :itemGridModifications="itemGridModifications" @cancel="showTransferOrderEdit = false; selectedTransferOrderClone = null;" />
        </v-dialog>
        
    </v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import TransferOrderEdit from '@/components/Integrations/Netsuite/TransferOrderEdit';
export default {
    name: 'TransferOrders',
    props: ['issue_id', 'newIssue'],
    components: {
        'ag-grid-vue': AgGridVue,
        TransferOrderEdit
    },
    data: () => ({
        resources: null,
        transferOrders: [],
        gridOptions: null,
        showGrid: false,
        lockSave: false,
        showTransferOrderEdit: false,
        selectedTransferOrderClone: null,
        itemGridModifications: null,
        gettingNetsuiteResources: false
    }),

    computed: {

    },

    methods: {
        getTransferOrdersList: function() {
            TELSA.loading(true);
            this.showGrid = false;
            let route = (TELSA.apiHost + "integrations/netsuite/transferorders/list");
            return this.$http.post(route, {args: {issue_id: this.$props.issue_id}}).then(response => {
                let results = response.body;
                this.transferOrders = results;
            });
        },

        manualResyncResources: function() {
            this.gettingNetsuiteResources = true;
            this.getTransferOrderResources(true).then(r => {
                this.gettingNetsuiteResources = false;
            });
        },

        getTransferOrderResources: function(force=false) {
            // Check indexDB Store
            return TELSA.IDB.get('netsuiteStore', 'resources').then(netsuiteStoreResources => {
                let resourceKey = netsuiteStoreResources ? netsuiteStoreResources.resource_key : '';
                let self = this;
                const getResourcesFunc = function(key) {
                    let route = (TELSA.apiHost + "integrations/netsuite/transferorders/resources");
                    return self.$http.post(route, {args: {resource_key: key}}).then(response => {
                        let results = response.body;
                        if(results == 'cache') {
                            console.log('use ns cache in index db');
                            self.resources = netsuiteStoreResources.resource_data;
                        }
                        else if(results == 'expired') {
                            console.log('NS resources are expired. Pull latest data.');
                            self.gettingNetsuiteResources = true;
                            TELSA.loading(false);
                            return getResourcesFunc('expired');
                        }
                        else {
                            self.resources = results.resource_data;
                            console.log('SETTING DATE TO INDEX DB!!');
                            return TELSA.IDB.set('netsuiteStore', 'resources', results).then(r => {
                                console.log('saved resources in index db');
                            });
                        }
                    });
                };
                return force ? getResourcesFunc('expired') : getResourcesFunc(resourceKey);
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.transferOrders;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.columnApi.autoSizeAllColumns();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport'
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle transfer-order-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle transfer-order-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.transfer-order-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.transfer-order-action')[1];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            this.editTransferOrder(params.data);
                        },
                        deleteFunction: (params) => {
                            if(!self.lockSave) {
                                this.deleteTransferOrderClick(params.data);
                            }
                        }
                    }
                },
                { 
                    headerName: 'ID',
                    field: 'id',
                    width: 40, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.id;
                    }
                },
                { 
                    headerName: 'Created On',
                    field: 'created_on',
                    width: 90, filter: 'agDateColumnFilter', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        //return TELSA.moment(params.data.createdDate).format('YYYY-MM-DD HH:mm:ss');
                        //return params.data.createdDate;
                        return params.data.tranDate;
                    }
                },
                { 
                    headerName: 'Document Number',
                    field: 'document_number',
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.tranId || "";
                    }
                },
                { 
                    headerName: 'Subsidiary',
                    field: 'subsidiary',
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        if(params.data.subsidiary) {
                            let subsidiary = self.resources.subsidiaries.find(s => s.value == params.data.subsidiary);
                            if(subsidiary) {
                                return subsidiary.text;
                            }
                        }
                        return "";
                    }
                },
                { 
                    headerName: 'Status',
                    field: 'status',
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.status;
                    }
                },
                { 
                    headerName: 'Item Fulfillment Status',
                    field: 'item_fulfillment_status',
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.itemFulfillmentStatus || "";
                    }
                },
                { 
                    headerName: 'Memo',
                    field: 'memo',
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.memo || "";
                    }
                },
                { 
                    headerName: 'Employee',
                    field: 'employee',
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        if(params.data.subsidiary) {
                            let employee = self.resources.employees.find(e => e.id == params.data.employee);
                            if(employee) {
                                return employee.entityId;
                            }
                        }
                        return "";
                    }
                },
                { 
                    headerName: 'Scheduled Delivery Date',
                    field: 'scheduled_delivery_date',
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.scheduledDeliveryDate || "";
                    }
                },
                { 
                    headerName: 'Shipping Carrier',
                    field: 'shipping_carrier',
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.shippingCarrier || "";
                    }
                },
                { 
                    headerName: 'Tracking Number',
                    field: 'tracking_number',
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            if(params.data.trackingNumber) {
                                this.eGui.innerHTML = `<span class="to-tracking-number">${params.data.trackingNumber}</span>`;
                                this.trackingLink = this.eGui.querySelectorAll('.to-tracking-number')[0];
                                this.linkClickHandler = this.linkClickHandler.bind(this);
                                this.trackingLink.addEventListener('click', this.linkClickHandler);
                            }
                            else {
                                this.eGui.innerHTML = '';
                            }
                        }
                        getGui() {
                            return this.eGui;
                        }
                        linkClickHandler(event) {
                            if(this.params.data.shippingCarrier && this.params.data.trackingNumber) {
                                let shippingService = this.params.data.shippingCarrier;
                                let trackingNumber = this.params.data.trackingNumber;
                                console.log(`${shippingService}: ${trackingNumber}`);
                                if(shippingService.toUpperCase() == 'DHL') {
                                    window.open(`https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=${trackingNumber.replace(/\s+/g, '')}`, "_blank");
                                }
                                else if(shippingService.toUpperCase() == 'FEDERAL EXPRESS') {
                                    window.open(`https://www.fedex.com/fedextrack/?trknbr=${trackingNumber.replace(/\s+/g, '')}`, "_blank");
                                }
                                else if(shippingService.toUpperCase() == 'DSV AIR & SEA') {
                                    window.open(`https://mydsv.com/track-shipment?query=${trackingNumber.replace(/\s+/g, '')}`, "_blank");
                                }
                                else if(shippingService.toUpperCase() == 'SUNSHINE STATE MESSENGER') {
                                    window.open(`https://sunshinedelivers.com/`, "_blank");
                                }
                                else if(shippingService.toUpperCase() == 'UPS') {
                                    window.open(`https://ups.com/track?loc=en_US&requester=QUIC&tracknum=${trackingNumber.replace(/\s+/g, '')}`, "_blank");
                                }
                                else if(shippingService.toUpperCase() == 'VESSEL LOGISTICS PROVIDER') {
                                    // This is just a place holder
                                }
                            }
                        }
                        destroy() {
                            if(this.trackingLink) {
                                this.trackingLink.removeEventListener('click', this.linkClickHandler);
                            }
                        }
                    },
                },
                { 
                    headerName: 'Item Receipt Memo',
                    field: 'item_receipt_memo',
                    width: 90, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.itemReceiptMemo || "";
                    }
                },
            ];
            return columnDefs;
        },

        addTransferOrderClick: function() {
            // If this issue is brand new and has never been saved, then we need to do that now
            if(this.$props.newIssue) {
                this.$store.commit('showConfirmModal', {
                    title: 'Save Issue?',
                    message: `You must save this new Issue before you can create a NetSuite transfer Order. Save now?`,
                    type: '',
                    confirmAction: () => { this.$emit('saveIssue'); }
                });
            }
            else {
                this.addTransferOrder();
            }
        },

        addTransferOrder: function() {
            this.selectedTransferOrderClone = {
                items: [],
                //'id': transfer_order['id'],
                'customForm': '112',
                //'tranId': transfer_order['tranId'],
                'tranDate': '',
                'subsidiary': '4',
                'location': '',
                'transferLocation': '',
                'employee': '',
                'status': 'Pending Fulfillment',
                'firmed': true,
                'memo': '',
                'useItemCostAsTransferCost': true,
                'custbody_aw_terms': '',
                'telsasoft_memo': `TS_${this.$props.issue_id}_${this.transferOrders.length + 1}`
            },
            this.showTransferOrderEdit = true;
        },

        editTransferOrder: function(transferOrder) {
            // Build a transfer order object that uses the correct fields for saving the TO
            this.selectedTransferOrderClone = JSON.parse(JSON.stringify(transferOrder));
            this.showTransferOrderEdit = true;
        },

        deleteTransferOrderClick: function(transferOrder) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete Transfer Order',
                message: `You are about to delete this transfer order from NetSuite and Telsasoft. This cannot be undone. Are you sure you want to delete this transfer order?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteTransferOrder(transferOrder)
            });
        },

        deleteTransferOrder: function(transferOrder) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "integrations/netsuite/transferorders/delete");
            this.$http.post(route, {args: {lock: this.$store.state.lock, issue_id: this.$props.issue_id, transferOrder: transferOrder}}).then(response => {
                let results = response.body;
                this.getTransferOrdersList().then(r => {
                    this.buildAgGrid();
                    TELSA.loading(false);
                });
            });
        },

        saveTransferOrder: function() {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "integrations/netsuite/transferorders/edit");
            if(!this.selectedTransferOrderClone.tranId) {
                route = (TELSA.apiHost + "integrations/netsuite/transferorders/add");
            }
            this.$http.post(route, {args: {lock: this.$store.state.lock, issue_id: this.$props.issue_id, transferOrder: this.selectedTransferOrderClone}}).then(response => {
                let results = response.body;
                this.showTransferOrderEdit = false;
                this.selectedTransferOrderClone = null;
                this.getTransferOrdersList().then(r => {
                    this.buildAgGrid();
                    TELSA.loading(false);
                });
            });
        },

        getItemGridModifications: function () {
            return this.$store.dispatch('getConfigItem', {key: 'netsuite_items_grid_state'}).then(response => {
                let result = response.body;
                this.itemGridModifications = result ? JSON.parse(result) : null;
            });
        },
    },

    mounted() {
        let promises = [];
        promises.push(this.getTransferOrderResources(false));
        promises.push(this.getTransferOrdersList());
        promises.push(this.getItemGridModifications());
        Promise.all(promises).then(r => {
            TELSA.loading(false);
            this.gettingNetsuiteResources = false;
            this.buildAgGrid();
        });
    }

  
};
</script>

<style scoped>

    .title-area {
        display: block;
    }

    .title-area .title.ns {
        vertical-align: top;
        padding-top: 8px;
        margin-left: 6px;
        display: inline-block;
    }

    .transfer-orders-area {
        display: block;
    }

    #netsuite-transfer-order-ag-grid-container {
        height: calc(100vh - 540px);
        min-height: 400px;
        width: 100%;
    }

    .getting-ns-resources {
        display: block;
        text-align: center;
        padding-top: calc(50vh - 300px);

    }
    .getting-ns-resources span {
        font-size: 38px;
    }
    .getting-ns-resources .progress-bar {
        width: 494px;
        margin-left: calc(50% - (494px / 2));
        margin-top: 12px;
    }

</style>

<style>

    #netsuite-transfer-order-ag-grid-container .ag-theme-balham {
        /* --ag-header-height: 60px !important; */
        --ag-header-foreground-color: white;
        --ag-header-background-color: #C74634;
        
        --ag-header-cell-hover-background-color: #C74634 !important;
        --ag-header-cell-moving-background-color: #C74634 !important;
        
        /* font-weight: bold !important; */
        font-family: Open Sans,Helvetica,sans-serif;

        font-size: 14px;
    }

    #netsuite-transfer-order-ag-grid-container .ag-theme-balham .ag-header {
        height: 40px !important;
    }

    #netsuite-transfer-order-ag-grid-container .ag-theme-balham .ag-header-cell {
        font-size: 16px;
        font-weight: bold;
    }

</style>
